<template>
  <section class="tariff-single-shell">
    <p class="tariff-note is-success" v-if="success">
      {{ success }} <i class="tiny material-icons">check_circle</i>
    </p>
    <p class="tariff-note is-error" v-if="error">{{ error }}</p>

    <form @submit.prevent="handleSubmit" class="tariff-single-form">
      <div class="tariff-single-card">
        <div>
          <label class="active teal-text" for="item">Tariff Item</label>
          <input id="item" type="text" v-model="item" />
        </div>
        <div>
          <label class="active teal-text" for="price">Unit Price</label>
          <input id="price" type="number" step="0.01" v-model="price" />
        </div>
      </div>

      <div class="tariff-single-submit">
        <div>
          <span>Add one item</span>
          <small>This adds a provider-specific tariff item to the current schedule.</small>
        </div>
        <button
          class="waves-effect waves-light btn"
          :class="{
            disabled: !item || !price || isSubmitting,
          }"
        >
          <i class="material-icons left">check_circle</i>{{ isSubmitting ? `Adding ...` : "Add Item" }}
        </button>
      </div>
    </form>
  </section>
</template>
    
<script>
import { ref } from "vue";
import postItem from "@/composables/postItem";

export default {
  name: "AddSingleTariffComponent",
  props: ["provider"],
  emits: ["update"],
  setup(props, context) {
    const item = ref(null);
    const price = ref(null);
    const isSubmitting = ref(false);
    const success = ref(null);
    const error = ref(null);

    const clearForm = () => {
      item.value = null;
      price.value = null;
      isSubmitting.value = false;
    };

    const clearMsg = () => {
      success.value = null;
      error.value = null;
    }

    const handleSubmit = async () => {
      // start
      clearMsg();
      // submitting
      isSubmitting.value = true;

      // put all together
      let newVal = { 
        item: item.value,
        price: price.value,
        version: null,
        schedule_id: props.provider.schedule_id,
        scope: props.provider.id,
       };

      // post item
      const { res, err } = await postItem("tariff/add", newVal);

      if (res.value) {
        // final end
        success.value = `${item.value} at N${price.value} added!`;

        // tariff update
        context.emit("update", true);

      } else {
        error.value = `Error: ${item.value} not added! (${err.value})`;
      }

      clearForm();
    };


    return {
      handleSubmit,
      isSubmitting,
      success,
      error,
      item,
      price,
    };
  },
};
</script>
    
<style scoped>
.tariff-single-shell {
  display: grid;
  gap: 14px;
}

.tariff-note {
  border-radius: 6px;
  display: inline-flex;
  font-weight: 700;
  gap: 8px;
  margin: 0;
  max-width: max-content;
  padding: 9px 12px;
}

.tariff-note.is-success {
  background: #e8f5e9;
  color: #1b5e20;
}

.tariff-note.is-error {
  background: #ffebee;
  color: #b71c1c;
}

.tariff-single-form {
  background: #ffffff;
  border: 1px solid #e3eaed;
  border-radius: 6px;
  box-shadow: 0 18px 32px -30px rgba(38, 50, 56, 0.72);
  display: grid;
  gap: 0;
  overflow: hidden;
}

.tariff-single-card,
.tariff-single-submit {
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.tariff-single-card {
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(0, 1.4fr) minmax(180px, 0.6fr);
  padding: 20px;
}

.tariff-single-card label {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.tariff-single-card input {
  border-bottom-color: #b0bec5;
  color: #263238;
  font-weight: 700;
  margin: 0;
}

.tariff-single-submit {
  align-items: center;
  background: #fafafa;
  border-top: 1px solid #eef3f5;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 16px 18px;
}

.tariff-single-submit span {
  color: #263238;
  display: block;
  font-weight: 700;
}

.tariff-single-submit small {
  color: #607d8b;
  display: block;
  margin-top: 4px;
}

.tariff-single-submit button {
  background: #00897b;
  border-radius: 6px;
  box-shadow: none;
  flex: 0 0 auto;
  font-weight: 700;
  text-transform: none;
}

@media only screen and (max-width: 700px) {
  .tariff-single-card {
    grid-template-columns: 1fr;
  }

  .tariff-single-submit {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
